import { PredicateHierarchy, ReadableTime } from './types'
import {
    aDay,
    anHour,
    aWeek,
    catchAll,
    justNow,
    lessThanAnHour,
    moreThanADay,
    moreThanAnHour,
    moreThanAWeek,
    lessThanAMinute,
    aMinute,
    moreThanAMinute,
    lessThanTwoHours,
    lessThanADay,
    pastCheck,
} from './predicates'

export const JUST_NOW_DELTA = 15 // in minutes
export const MINUTES_IN_DAY = 1440 /* 24 * 60 */
export const JUST_NOW_MESSAGE = 'Just now'
export const DEFAULT_DATE_FORMAT = 'dd MMM yyyy'

const baseHierarchy: ReadableTime[] = [
    pastCheck,
    justNow,
    lessThanAnHour,
    anHour,
    moreThanAnHour,
]

const defaultHierarchy: ReadableTime[] = [...baseHierarchy, catchAll]
const eventPostHierarchy: ReadableTime[] = [
    pastCheck,
    lessThanAMinute, // Just now
    aMinute, // 1 minute ago
    moreThanAMinute, // x mins ago
    lessThanTwoHours, // 1 hour ago
    lessThanADay, // x hours ago
    catchAll,
]

const perthNowCardsHierarchy: ReadableTime[] = [
    ...baseHierarchy,
    aDay,
    moreThanADay,
    catchAll,
]

const theNightlyNotificationCentreHierarchy: ReadableTime[] = [
    ...baseHierarchy,
    aDay,
    moreThanADay,
    aWeek,
    moreThanAWeek,
    catchAll,
]

export const GetReadableTimePredicateHierarchy = {
    default: defaultHierarchy,
    eventPost: eventPostHierarchy,
    perthNowCards: perthNowCardsHierarchy,
    theNightlyNotificationCentre: theNightlyNotificationCentreHierarchy,
}
